import type { LifecycleRetreat } from "../../../../types/retreatLifecycle";
import { SUPPORT_TYPE_LABELS } from "../projected/projectedRetreatConstants";
import { formatLanguage } from "../lifecycle/lifecycleUi";

export type SectionKey =
  | "projected"
  | "inSetup"
  | "registrationOpen"
  | "closing"
  | "completed"
  | "deleted";

export const SECTION_IDS: Record<SectionKey, string> = {
  registrationOpen: "registration-open",
  inSetup: "in-setup",
  closing: "closing",
  projected: "projected",
  completed: "closed-retreats",
  deleted: "deleted",
};

export const emptySearch: Record<SectionKey, string> = {
  projected: "",
  inSetup: "",
  registrationOpen: "",
  closing: "",
  completed: "",
  deleted: "",
};

export function projectedSupportParts(r: LifecycleRetreat) {
  const typeLabel = SUPPORT_TYPE_LABELS[String(r.supportType || "")] || "";
  const couple =
    r.supportLabel && r.supportLabel !== "—" ? r.supportLabel : "";
  return { typeLabel, couple };
}

export function retreatDisplayTitle(r: LifecycleRetreat) {
  const parish = r.parishName || r.title || "Untitled retreat";
  const lang = formatLanguage(r.language);
  return lang && lang !== "—" ? `${parish} · ${lang}` : parish;
}

export function retreatLocationLine(r: LifecycleRetreat) {
  if (!r.location) return "";
  return `${r.location.charAt(0).toUpperCase()}${r.location.slice(1)}`;
}
